import * as React from 'react';
import classNames from 'classnames';
import style from './flex.scss';

type DivElementProps = JSX.IntrinsicElements['div'];

export interface FlexProps extends DivElementProps {
  wrap?: string;
  flex?: string;
  inline?: boolean;
  grow?: Number;
  direction?: string;
  alignItems?: string;
  alignContent?: string;
  justifyContent?: string;
  wrapperComponent?: string | React.ComponentClass;
  className?: string;
}

export function Flex({
  wrap = 'nowrap',
  flex,
  inline = false,
  grow,
  direction,
  alignItems,
  alignContent,
  justifyContent,
  wrapperComponent = 'div',
  style: propsStyle = {},
  children,
  className = '',
  ...restProps
}: FlexProps) {
  const flexProps: any = {
    style: {
      ...propsStyle,
      flexDirection: direction,
      flexWrap: wrap,
      flex,
      alignItems,
      alignContent,
      justifyContent,
    },
    className: classNames(className, style.flex, {[style.inline]: inline}),
    ...restProps,
  };

  if (grow !== undefined) {
    flexProps.style.flexGrow = grow;
  }

  return React.createElement(wrapperComponent, flexProps, children);
}

export default Flex;
